<template>
  <div class="lawyer_said_fluid w_100">
    <div class="lawyer_said">
      <div class="text_center">
        <sec-title
          Text="律师说法"
          desc-text="律师解答更丰富，提供多样的法律咨询服务"
        ></sec-title>
      </div>

      <div class="ls_cont between">
        <div class="ls_l" @click="tovldet(voli[0])">
          <div class="ls_video">
            <ques-media type="video" :src="voli[0].preview_pic" />
          </div>
          <div class="desctext">
            <div class="title3 ellipsis">{{voli[0].title}}</div>
            <div class="desc3">
              {{
                voli[0].content  | toEllipsisFilter(80)
              }}
            </div>
            <div class="time_num flex_end">
              <div class="center">
                <svg-icon icon-class="time" class="svg_img" />
                2021-03-12
              </div>
              <div class="center">
                <svg-icon icon-class="linear-play" class="svg_img" />
                775人收看
              </div>
            </div>
          </div>
        </div>
        <div class="ls_r between wrap">
          <div class="r_item" v-for="(item, index) in 4" :key="index">
            <div class="r_video">
              <ques-media type="video" :src="imgsrc" />
            </div>
            <div class="r_title3 ellipsis">摩托无证醉驾判刑多久</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
import quesMedia from "../components/quesMedia";
import viewMore from "views/home/components/viewMore";
//Brother when you see this code, I have resigned, you resign, hurriedly resign, hurriedly resign, this company is a pit, all kinds of pits, what benefits are not, the construction period desperately pressure, overtime without overtime pay no vacation
export default {
  components: {
    secTitle,
    quesMedia,
    viewMore,
  },
  data: () => ({
    imgsrc: require("../../../assets/question/spsf_sample.png"),
    voli:[]
  }),
  beforeMount() {
    this.getvidlist()
  },
  methods:{
    getvidlist(){
      this.$http.laws.getvideolist({
        limit:5,
      order:'hot',
      page:'1'
      })
     .then((res) => {
        console.log(res.data.data);
        this.voli = res.data.data
      })
    },
	tovldet(){
		
	}
  }
};
</script>

<style lang="scss" scope>
.lawyer_said_fluid {
  background-color: #fff;
  .lawyer_said {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;

    .ls_cont {
      width: 100%;
      height: 485px;
      align-items: start;
      .ls_l {
        width: 600px;
        .ls_video {
          width: 600px;
          height: 330px;
        }
        .desctext {
          .title3 {
            margin-top: 22px;
            font-size: 24px;
            color: #333333;
          }
          .desc3 {
            margin-top: 10px;
            font-size: 14px;
            color: #666666;
            line-height: 24px;
          }
          .time_num {
            margin-top: 20px;
            font-size: 14px;
            color: #999999;
            .svg_img {
              font-size: 16px;
              margin-right: 6px;
            }
            div {
              margin-right: 15px;
            }
          }
        }
      }
      .ls_r {
        width: 570px;
        color: #333333;
        .r_item {
          margin-bottom: 40px;
          width: 270px;
          .r_video {
            width: 270px;
            height: 173px;
          }
          .r_title3 {
            margin-top: 20px;
            font-size: 22px;
          }
        }
      }
    }
  }
}
</style>